import { z } from "zod";
const attributesTabSchema = z.object({
  id: z.string(),
  title: z.string()
});
const attributesTabsSchema = z.object({
  children: z.array(attributesTabSchema),
  default: z.string().optional(),
  isMdx: z.boolean().optional()
});
export {
  attributesTabSchema,
  attributesTabsSchema
};
//# sourceMappingURL=attributes.js.map
